module.exports = __webpack_public_path__ + "static/media/thumb.b779261d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/new-mills-incubator/thumb.jpg
// module id = 47
// module chunks = 0